<template>
    <el-container >
        <el-main :style="isDialogChoose?'margin-top: -3%':''">
            <div  :class="isDialogChoose?'tools-bar-pop':'tools-bar'" >
                <div  class="tools-search"  @keyup.enter="_initPage">
                    <el-form :inline="true" class="demo-form-inline">
                        <el-row v-if="isDialogChoose">
                          <!-- <el-col :span="3">
                            选中模板:
                          </el-col>
                          <el-col class="choosedClass" :span="15">
                              <font style="font-size: 18px;" color='green'>{{callActivityConfig.templateName}}</font>
                          </el-col>  -->

                            <el-col :span="12">
                              <el-form-item label="选中模板:">
                                  <div> <font style="font-size: 18px;" color='green'>{{callActivityConfig.templateName}}</font></div>
                              </el-form-item>
                            </el-col>
                            <el-col  v-if="isShowOrder" :span="12">
                                <el-form-item label="列表显示顺序">
                                  <el-tooltip  content="在流程任务列表里显示的顺序，为0则表示不排序，数字从1开始按递增顺序排序" effect="light" placement="top">
                                    <el-input-number v-model="callActivityConfig.viewOrder" :min="0" :max="100" label="列表显示顺序"></el-input-number>
                                  </el-tooltip>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                          <i class="el-icon-back"  v-if="!hiddenReturn" @click="showList" style="cursor: pointer;color:#409eff;"></i>
                          <el-form-item label="流程定义">
                              <el-select v-model="searchParams.key" clearable @change="_initPage" placeholder="请选择">
                                  <el-option
                                  v-for="item in processDefineList"
                                  :key="item.key"
                                  :label="item.name"
                                  :value="item.key">
                                  </el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item v-if="!isDialogChoose" label="版本范围">
                              <el-select  v-model="searchParams.state" @change="_initPage" placeholder="请选择">
                                  <el-option
                                      v-for="item in processState"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value">
                                  </el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="流程方案">
                              <el-input style="width: 250px;" maxlength="100" v-model.trim="searchParams.serviceName" >
                                  <el-button slot="append" icon="el-icon-search" @click="_initPage"></el-button>
                              </el-input>
                              <el-badge>
                                 <el-popover
                                     placement="bottom"
                                     title=""
                                     width="230"
                                     trigger="hover">
                                     &nbsp;&nbsp;流程模板是发起流程实例的基础，新生成的流程模板必须进行任务按钮和网关条件的配置，否则发起的流程实例执行到条件网关时就会无法进行下去了。
                                     <el-button slot="reference" circle icon="el-icon-question"></el-button>
                                 </el-popover>
                              </el-badge>
                            </el-form-item>

                        </el-row>
                        <!-- <el-form-item>
                            <el-button type="primary" @click="handleSearch">查询</el-button>
                        </el-form-item> -->
                    </el-form>
                </div>
            </div>
            <div :class="isDialogChoose?'template-list-pop':'process-template-list'">
                <el-card :class="(activeClass === index) || (isMulti && process.isSelected) ? 'choosedProcessClass':''" v-for="(process,index)  in templateList" :key="process.id" shadow='hover' class="process-item" :body-style="{ padding: '0px' }">
                      <div class="process-top">
                         <el-tag type="info" class="process-version">发布版本: v{{process.version}}</el-tag>
                          <template v-if="!isDialogChoose">
                             <el-badge class="badge-item" v-permission="permission.configProcessTemplateBtn">
                              <el-popover
                                  style="margin-left:2px;float:right"
                                  placement="left"
                                  title="模板使用说明："
                                  width="200"
                                  trigger="hover"
                                  :content="process.templateDesc?process.templateDesc:process.description">
                                      <el-button icon="el-icon-edit-outline" @click="handleOpenTemplateInfo(0,process)" circle slot="reference"></el-button>
                              </el-popover>
                            </el-badge>
                            <el-tooltip class="item" effect="dark" content="模板预览" placement="top">
                                <el-badge class="badge-item" v-permission="permission.previewProcessTemplateBtn">
                                    <el-button style="margin-left:2px;float:right"  icon="el-icon-view" circle @click="handleViewTemplate(process)"></el-button>
                                </el-badge>
                            </el-tooltip>
                             <el-tooltip class="item" effect="dark" content="再次发布" placement="top">
                                <el-badge class="badge-item" v-permission="permission.publishProcessTemplateBtn">
                                    <el-button style="margin-left:2px;float:right" type="success"  icon="el-icon-caret-right" circle @click="handleOpenTemplateInfo(1,process)"></el-button>
                                </el-badge>
                            </el-tooltip>
                          </template>
                    </div>
                    <div class="process-img" :style="_getProcessImgStyle(process)"  @click="handleNavProcess(process,index)">
                    </div>
                    <div class="process-bottom">
                        <div>
                            <div ><font style="font-size: 18px;" color='green'>{{process.templateName?process.templateName:process.processServiceName}}</font> <br/> [方案]<font color='blue'>{{process.processServiceName}}</font> </div>
                        </div>
                        <div v-if="!isDialogChoose" class="process-btns">
                            <!-- <el-button  type="success" size="mini" icon="el-icon-caret-right" title="再次发布" circle @click="handlePublishProcess(process)"></el-button> -->
                            <el-badge class="badge-item" v-permission="permission.startProcessTemplateBtn">
                                <el-button style="margin-left:2px;float:right" v-show="!hiddenStartProcess" type="primary" title="发起流程" plain @click="handleStartProcess(process)">发起流程</el-button>
                            </el-badge>
                        </div>
                    </div>
                </el-card>
            </div>
            <el-dialog
                title="流程预览"
                width="80%"
                append-to-body
                :fullscreen=true
                :visible.sync="isShowSetting"
                >
                <ProcessSetting
                    :key="loadTimer"
                    :processInstance="processInstance"
                    :isShowTitle="false"
                    :taskList="taskList"
                    :archiveTemplateTreeList="archiveTemplateTreeList"
                />
                <span slot="footer" class="dialog-footer">
                    <el-button @click="isShowSetting=false">取 消</el-button>
                </span>
            </el-dialog>
            <el-dialog
                class='processPopClass'
                title="启动流程"
                top="0vh"
                width="80%"
                append-to-body
                :visible.sync="isShowStartProcessDialog">
                <ProcessInstancePop :key="loadTimer" ref="processInstancePop" :isReturnToNav="isReturnToNav" :isNewModePage="isNewModePage"  @handleClosePop="handleClosePop" @navToBusiniessProcessTab="navToBusiniessProcessTab"  @navToBusiniessTaskTab="navToBusiniessTaskTab"/>
            </el-dialog>
        </el-main>
        <el-dialog
            title="模板明细"
            width="60%"
            top="1vh"
            :visible.sync="isShowTemplateDesc"
            >
            <TemplatePop :key="loadTimer" ref="templatePop" :templateInfo="templateInfo"/>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowTemplateDesc=false">取 消</el-button>
                <el-button v-if="saveMode===0" type="primary" @click="handleEditTemplateInfo">确 定</el-button>
                <el-button v-if="saveMode===1" type="primary" @click="handleEditTemplateInfo">发 布</el-button>
            </span>
        </el-dialog>
        <el-dialog
            custom-class="process-Template-dialog"
            title=""
            append-to-body
            :fullscreen=true
            :visible.sync="isShowConsole"
            >
            <WorkflowEditor
                style="height: 1100px;"
                v-if="isShowConsole"
                ref="workflowEditor"
                :key="loadTimer"
                :processType="workflowProcessType"
                :workflowProcessDefinitionId="workflowProcessDefinitionId"
                :workflowProcessServiceId="workflowProcessServiceId"
                :workflowDeploymentId="workflowDeploymentId"
                />
        </el-dialog>
    </el-container>
</template>

<script>
    import { getProcessInstancesCnt, getSerialNumber, getUserList, getProcessServiceTemplate, getBusinessTreeList, getArchiveTemplateList, getArchiveTemplateTreeList, getAllUserTask, getProcessTemplateList, startProcess, publishProcessTemplate, saveProcessTemplate, getActivitiThumbnailUrl, getProcessList } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';
    import { isEmpty, cloneDeep } from 'lodash';
    import TemplatePop from './TemplatePop';
    import ProcessInstancePop from './ProcessInstancePop';
    // import ProcessSetting from '../MyProcess/ProcessSetting';
    // import WorkflowEditor from '../ProcessEditor/WorkflowEditor';
    // import DataOperateEdit from '../ProcessEditor/components/DataOperateEdit';
    import { CONST_PERMISSION_PROCESS_START_PROCESS_TEMPLATE_BTN,
        CONST_PERMISSION_PROCESS_DESIGN_PROCESS_TEMPLATE_BTN,
        CONST_PERMISSION_PROCESS_PUBLISH_PROCESS_TEMPLATE_BTN,
        CONST_PERMISSION_PROCESS_PREVIEW_PROCESS_TEMPLATE_BTN,
        CONST_PERMISSION_PROCESS_CONFIG_PROCESS_TEMPLATE_BTN
    } from '@/common/constants';

    export default {
        components: {
            // ProcessSetting,
            // DataOperateEdit,
            TemplatePop,
            ProcessInstancePop
            // WorkflowEditor
        },
        mixins: [ mixinsNav ],
        data () {
            return {
                reSetLoading: false,
                isShowProcessUserOrg: false,
                selectedProcessUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                selectedCandidateUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                isShowCandidateUserOrg: false,
                selectedUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                isShowUserOrg: false,
                loadTimer: '',
                workflowProcessType: 'edit',
                workflowProcessDefinitionId: '',
                workflowProcessServiceId: '',
                workflowDeploymentId: '',
                isShowConsole: false,
                activeClass: -1,
                tabName: 'first',
                archiveTemplateList: [],
                userList: [],
                isShowSetting: false,
                processState: [
                    {
                        value: 1,
                        label: '最新版'
                    }, {
                        value: 2,
                        label: '全部版本'
                    }],
                processDefineList: [ {
                    value: '',
                    label: '全部'
                }],
                templateList: [],
                searchParams: {
                    key: '',
                    serviceName: '',
                    definitionName: '',
                    state: 1 // 版本范围 ：默认 最新版
                },
                taskList: [],
                archiveTemplateTreeList: [],
                processInstance: {
                    processServiceName: '',
                    name: ''
                },
                isShowStartProcessDialog: false,
                startProcessloading: false,
                processInstanceInfo: {
                    processServiceId: '',
                    instanceName: '',
                    deploymentId: '',
                    executeType: 1, // 1由已配置的负责人执行   2固定设置所有节点的任务负责人
                    assignedUserId: '',
                    candidateUsers: ''
                },
                isShowTemplateDesc: false, //
                templateInfo: {
                    processServiceName: '',
                    processServiceId: '',
                    deploymentId: '',
                    id: '',
                    templateName: '',
                    templateDesc: '',
                    archiveTemplateId: '', // 档案模板
                    archiveTemplateName: '',
                    timeTemplateId: '', // 项目模板
                    timeTemplateName: '',
                    closeTemplateId: '', // 闭环模板
                    closeTemplateName: '',
                    processServiceType: '',
                    nameGenerationMode: '',
                    defaultFirstAssignee: 0, // 是否默认首任务负责人为发起人
                    parentProcessInstanceMode: 0, // 关联上级流程是否必填：0否1是，默认为0
                    processTaskAssignerMode: 0, // 流程所有任务的负责人是否必填：0否1是，默认为0
                    autoCompleteTask: 0,
                    canViewAllFile: 0,
                    claimMode: 0, // 任务认领模式
                    completeFirstTask: 0, // 立即执行首任务
                    planTimeMode: 0, // 默认不进行默认计划时间
                    processViewPanes: null,
                    taskViewPanes: null,
                    processExtJson: null,
                    dataOperate: {
                        dataSource: 2,
                        forms: []
                    },
                    processInstanceId: '',
                    parentProcessInstanceId: '',
                    parentProcessInstanceName: ''
                },
                businessTree: [],
                saveMode: 0, // 0:修改 1发布
                permission: {
                    startProcessTemplateBtn: [
                        CONST_PERMISSION_PROCESS_START_PROCESS_TEMPLATE_BTN
                    ],
                    designProcessTemplateBtn: [
                        CONST_PERMISSION_PROCESS_DESIGN_PROCESS_TEMPLATE_BTN
                    ],
                    publishProcessTemplateBtn: [
                        CONST_PERMISSION_PROCESS_PUBLISH_PROCESS_TEMPLATE_BTN
                    ],
                    previewProcessTemplateBtn: [
                        CONST_PERMISSION_PROCESS_PREVIEW_PROCESS_TEMPLATE_BTN
                    ],
                    configProcessTemplateBtn: [
                        CONST_PERMISSION_PROCESS_CONFIG_PROCESS_TEMPLATE_BTN
                    ]
                },
                initSelectedUsers: [], // 任务负责人
                selectedTask: {},
                selectedMap: new Map()
            };
        },
        created () {
            this._initProcessDefineList();
            this._initPage();
            this._queryUserList('');
        },
        computed: {
            candidateSelectFields: {
                get () {
                    if (isEmpty(this.processInstanceInfo.candidateUsers)) {
                        return [];
                    }
                    return this.processInstanceInfo.candidateUsers.split(',');
                },
                set (newVal, oldVal) {
                    this.processInstanceInfo.candidateUsers = newVal.join(',');
                }
            }
        },
        watch: {
            'callActivityConfig.calledElementProcessDefinitionId' (newVal, oldVal) {
                // this.setChoosedClass(newVal);
            }
        },
        props: {
            appId: {
                type: [Number, String],
                default: ''
            },
            isDialogChoose: {
                type: Boolean,
                default: false
            },
            isShowOrder: {
                type: Boolean,
                default: false
            },
            callActivityConfig: {
                type: Object,
                default: function () {
                    return {
                        processServiceId: '',
                        deploymentId: '',
                        callActivityId: '',
                        callActivityName: '',
                        calledElement: '',
                        calledElementProcessDefinitionId: '',
                        calledElementProcessServiceId: '',
                        calledElementDeploymentId: '',
                        templateName: '',
                        viewOrder: 0
                    };
                }
            },
            isMulti: {
                type: Boolean,
                default: false
            },
            selectedProcessTemplate: {
                type: Array,
                default: () => { return []; }
            },
            hiddenReturn: { // 隐藏返回的小按钮
                type: Boolean,
                default: false
            },
            isReturnToNav: {
                type: Boolean,
                default: false
            },
            isNewModePage: {
                type: Boolean,
                default: false
            },
            hiddenStartProcess: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            async _queryUserList (userName) {
                let userData = await getUserList({ name: userName });
                let sourceUsers = cloneDeep(userData.data);
                this.userList = [];
                sourceUsers.forEach(item => {
                    if (item.userId !== this.processInstanceInfo.assignedUserId) {
                        this.userList.push(item);
                    }
                });
            },
            async _initPage () {
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.searchParams.appId = this.appId;
                let { data } = await getProcessTemplateList(this.searchParams);
                if (!isEmpty(this.selectedProcessTemplate)) {
                    this.templateList = [];
                    for (var i = 0, len = data.length; i < len; i++) {
                        this.selectedProcessTemplate.forEach(target => {
                            if (data[i] && data[i].deploymentId === target.subDeploymentId) {
                                this.templateList.push(data[i]);
                            }
                        });
                    }
                } else {
                    this.templateList = data;
                }
                loading.close();

                let archiveTemplateList = await getArchiveTemplateList({ state: 1 });
                this.archiveTemplateList = archiveTemplateList.data;
                let treeList = await getBusinessTreeList();
                this.businessTree = treeList;
                this.setChoosedClass();
                this.selectedMap = new Map();
                // console.log("===="+this.permission.designProcessTemplateBtn);
            },
            setChoosedClass (newVal) {
                if (this.isDialogChoose) {
                    // console.log(newVal);
                    for (let i = 0, len = this.templateList.length; i < len; i++) {
                        if (this.templateList[i].id === this.callActivityConfig.calledElementProcessDefinitionId) {
                            if (!this.isMulti) { // 多选模式
                                this.activeClass = i;
                            } else if (newVal) {
                                if (this.templateList[i].id === newVal && this.selectedMap.has(newVal)) {
                                    this.templateList[i].isSelected = false;
                                    this.selectedMap.delete(newVal);
                                } else {
                                    this.templateList[i].isSelected = true;
                                    this.selectedMap.set(newVal, this.templateList[i]);
                                }
                            }
                        }
                    }
                }
            },
            async _initProcessDefineList () {
                let param = {};
                param.pageSize = 1000; // 不分页
                param.status = 1;// status为null 表示 启用和禁用的  status为1表示启用的
                // let processDefineList = await getProcessList({ status: 1 });
                let processDefineList = await getProcessList(param);
                this.processDefineList = processDefineList.data;
                this.processDefineList.unshift({value: '', name: '全部', key: ''});
                // console.log(processDefineList);
            },
            _getProcessImgStyle (process) {
                return {
                    'background-image': `url(${getActivitiThumbnailUrl(process.processDefinitionId)})`
                };
            },
            async handleStartProcess (process) {
                this.loadTimer = new Date().getTime();
                setTimeout(async () => { // 默认回显值
                    await this.$refs.processInstancePop.handleStartProcess(process);
                }, 0);
                this.isShowStartProcessDialog = true;
                // this.processInstanceInfo.instanceName = '';
                // await this.createProjectName(process);
                // this.processInstanceInfo.executeType = 1;
                // this.selectedUser = {
                //     selectedUserIds: '',
                //     selectedUserNames: ''
                // };
                // this.selectedCandidateUser = {
                //     selectedUserIds: '',
                //     selectedUserNames: ''
                // };
                // let currentUserStr = sessionStorage.getItem('currentUserInfo');
                // let currentUserInfo = JSON.parse(currentUserStr);
                // this.selectedProcessUser = {// 默认流程负责人为发起人
                //     selectedUserIds: currentUserInfo.userId,
                //     selectedUserNames: currentUserInfo.trueName
                // };
                // this.processInstanceInfo.id = process.id;
                // this.processInstanceInfo.processServiceId = process.processServiceId;
                // this.processInstanceInfo.deploymentId = process.deploymentId;
                // // console.log(process);
                // // console.log(this.processInstanceInfo);
                // this.taskList = [];
                // await this.changeExecuteType(1);
                // // 默认首任务负责人
                // if (this.templateInfo.defaultFirstAssignee) {
                //     if (this.taskList && this.taskList.length > 0) {
                //         let firstTaskNode = this.taskList[0];
                //         if (isEmpty(firstTaskNode.executor.assigneeUsers)) {
                //             firstTaskNode.executor.assigneeUsers = currentUserInfo.userId;
                //             firstTaskNode.executor.assigneeUsersName = currentUserInfo.trueName;
                //         }
                //     }
                // }
                // this.isShowStartProcessDialog = true;
                // this.startProcessloading = false;
            },
            async createProjectName (process) {
                let template = await getProcessServiceTemplate(process.processServiceId, process.deploymentId);
                // console.log(template);
                this.templateInfo.defaultFirstAssignee = template.defaultFirstAssignee;
                this.templateInfo.parentProcessInstanceMode = template.parentProcessInstanceMode;
                this.templateInfo.processTaskAssignerMode = template.processTaskAssignerMode;
                this.templateInfo.autoCompleteTask = template.autoCompleteTask;
                this.templateInfo.canViewAllFile = template.canViewAllFile;
                this.templateInfo.claimMode = template.claimMode;
                this.templateInfo.completeFirstTask = template.completeFirstTask;
                this.templateInfo.processViewPanes = template.processViewPanes;
                this.templateInfo.taskViewPanes = template.taskViewPanes;
                this.templateInfo.processExtJson = template.processExtJson;
                this.templateInfo.planTimeMode = template.planTimeMode;
                this.templateInfo.nameGenerationMode = template.nameGenerationMode ? template.nameGenerationMode : '';
                this.templateInfo.serialNumberJson = template.serialNumberJson ? template.serialNumberJson : '';
                if (this.templateInfo.nameGenerationMode && this.templateInfo.serialNumberJson) {
                    let node = JSON.parse(this.templateInfo.serialNumberJson);
                    if (this.templateInfo.nameGenerationMode === 'single') { // 单选
                        await this.setSerialNumber(node.value);
                    } else if (this.fieldSubType === 'multi') {
                        setTimeout(() => { // 默认回显值
                            this.$refs.treeChild._refreshSelectedNode(node);
                        }, 0);
                    }
                }
            },
            async setSerialNumber (sid) {
                let numberObj = await getSerialNumber(sid);
                // console.log(numberObj);
                this.processInstanceInfo.instanceName = numberObj.newSerialNumber;
                this.processInstanceInfo.recordId = numberObj.sn;
            },
            async reSetSerialNumber () {
                this.reSetLoading = true;
                let node = JSON.parse(this.templateInfo.serialNumberJson);
                if (this.templateInfo.nameGenerationMode === 'single') { // 单选
                    await this.setSerialNumber(node.value);
                }
                this.reSetLoading = false;
            },
            async handleSaveStartProcess () {
                let isValid = false;
                this.$refs['processInstanceForm'].validate((valid) => {
                    if (valid) {
                    // alert('submit!');
                        isValid = true;
                    } else {
                        isValid = false;
                    }
                });
                if (!isValid) {
                    return false;
                }
                let cntMap = await getProcessInstancesCnt(this.processInstanceInfo);
                if (cntMap.processInstanceCnt > 0) {
                    this.$confirm(`存在重名的流程实例名称,您确定要发起吗？`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async (res) => {
                        this.startProcess();
                    }).catch((error) => {
                        console.error(error);
                        return false;
                    });
                } else {
                    this.startProcess();
                }
            },
            async startProcess () {
                if (this.processInstanceInfo.executeType === 1) {
                    let assignedUserList = [];
                    this.taskList.forEach(item => {
                        let assignedUserId = '';
                        let assigneeUserName = '';
                        if (item.hasOwnProperty('assignedUserId')) {
                            assignedUserId = item.assignedUserId;
                            assigneeUserName = item.assigneeUserName;
                        } else if (item.executor.hasOwnProperty('assigneeUsers')) {
                            assignedUserId = item.executor.assigneeUsers;
                            assigneeUserName = item.executor.assigneeUsersName;
                        }
                        assignedUserList.push({taskId: item.taskId, taskName: item.taskName, assignedUserId: assignedUserId, assigneeUserName: assigneeUserName});
                    });
                    this.processInstanceInfo.assignedUserList = assignedUserList;
                }
                this.startProcessloading = true;
                try {
                    await startProcess(this.processInstanceInfo);
                } catch (error) {
                    this.startProcessloading = false;
                    console.error(error);
                    return;
                }
                this.startProcessloading = false;
                this.isShowStartProcessDialog = false;
                this.navMyProcess();
            },
            async handlePublishProcess (process) {
                let loading;
                this.$confirm(`您确定要发布[ ${process.templateName} ]吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    // await publishProcessService(process.processServiceId,process.deploymentId);
                    await publishProcessTemplate(process);
                    await this._initPage();
                    loading.close();
                }).catch((error) => {
                    loading.close();
                    console.error(error);
                });
            },
            async handleViewTemplate (process) {
                let tasks = await getAllUserTask(null, process.processServiceId, process.id, process.deploymentId);
                this.taskList = tasks;
                this.processInstance.id = '-1';
                this.processInstance.processServiceId = process.processServiceId;
                this.processInstance.processServiceName = process.processServiceName;
                this.processInstance.name = process.processServiceName;
                this.processInstance.deploymentId = process.deploymentId;
                this.processInstance.processDefinitionId = process.id;
                // console.log(this.processInstance);
                let treeList = [];
                if (process.archiveTemplateId) {
                    treeList = await getArchiveTemplateTreeList({templateId: process.archiveTemplateId});
                }
                this.archiveTemplateTreeList = treeList;
                this.loadTimer = new Date().getTime();
                this.isShowSetting = true;
            },
            handleNavProcess (process, index) {
                // console.log('双击用户任务节点');
                this.loadTimer = new Date().getTime();
                this.workflowProcessDefinitionId = '';
                this.workflowProcessServiceId = '';
                this.workflowDeploymentId = '';
                if (this.isDialogChoose) {
                    // console.log(index);
                    if (!this.isMulti) { // 多选模式
                        this.activeClass = index;
                    }
                    this.callActivityConfig.calledElement = process.key;// 最新版的key
                    this.callActivityConfig.calledElementProcessDefinitionId = process.id;
                    this.callActivityConfig.localProcessDefinitionId = process.processDefinitionId;
                    this.callActivityConfig.calledElementProcessServiceId = process.processServiceId;
                    this.callActivityConfig.calledElementDeploymentId = process.deploymentId;
                    this.callActivityConfig.templateName = process.templateName;
                    this.setChoosedClass(process.id);
                } else {
                    this.workflowProcessDefinitionId = process.processDefinitionId;
                    this.workflowProcessServiceId = process.processServiceId;
                    this.workflowDeploymentId = process.deploymentId;
                    this.isShowConsole = true;
                    // 直接跳转
                    // this.navWorkflowEditor(process.processDefinitionId, process.processServiceId, process.deploymentId);
                }
            },
            getSelectedProcessTemplate () {
                let selectedArr = [];
                // console.log(this.selectedMap);
                this.selectedMap.forEach(function (value, key) {
                    // console.log(value, key);
                    selectedArr.push(value);
                });
                return selectedArr;
            },
            chooseUser () {
                this.loadTimer = new Date().getTime();
                setTimeout(() => { // 初始化
                    this.$refs.userOrgPop._initPage();
                }, 0);
                this.isShowUserOrg = true;
            },
            selectTrigger (selected) {
                this.selectedUser = selected;
                this.processInstanceInfo.assignedUserId = selected.selectedUserIds;
                this.selectedTask.assignedUserId = selected.selectedUserIds;
                this.selectedTask.assigneeUserName = selected.selectedUserNames;
                if (this.selectedTask.hasOwnProperty('executor')) {
                    this.selectedTask.executor.assigneeUsers = selected.selectedUserIds;
                    this.selectedTask.executor.assigneeUsersName = selected.selectedUserNames;
                }
                this.loadTimer = new Date().getTime();
                // console.log(this.processInstanceInfo.assignedUserId);
            },
            chooseCandidateUser () {
                this.loadTimer = new Date().getTime();
                setTimeout(() => { // 初始化
                    this.$refs.candidateUserOrgPop._initPage();
                }, 0);
                this.isShowCandidateUserOrg = true;
            },
            selectCandidateUserTrigger (selected) {
                this.selectedCandidateUser = selected;
                this.processInstanceInfo.candidateUsers = selected.selectedUserIds;
            },
            async handleOpenTemplateInfo (mode, process) {
                // console.log(process);
                this.loadTimer = new Date().getTime();
                this.saveMode = mode;
                await this.setTemplateInfo(process);
                // this.resetShowStatus(process);
                this.isShowTemplateDesc = true;
                setTimeout(() => { // 默认回显值
                    this.$refs.templatePop._initPage(process);
                }, 0);
            },
            // resetShowStatus (process) {
            //     let node = {};
            //     node.value = process.processServiceType;
            //     node.title = process.processServiceTypeName;
            //     setTimeout(() => { // 默认回显值
            //         this.$refs.treeChild._refreshSelectedNode(node);
            //     }, 0);
            //     this.tabName = 'first';
            //     this.isShowTemplateDesc = true;
            // },
            async setTemplateInfo (process) {
                this.templateInfo.id = process.templateId;
                this.templateInfo.activityProcessDefinitionId = process.id;
                this.templateInfo.processServiceName = process.processServiceName;
                this.templateInfo.processServiceId = process.processServiceId;
                this.templateInfo.deploymentId = process.deploymentId;
                this.templateInfo.templateName = process.templateName ? process.templateName : process.processServiceName;
                this.templateInfo.templateDesc = process.templateDesc ? process.templateDesc : process.description;
                this.templateInfo.archiveTemplateId = process.archiveTemplateId;
                this.templateInfo.timeTemplateId = process.timeTemplateId;
                this.templateInfo.closeTemplateId = process.closeTemplateId;
                let template = await getProcessServiceTemplate(process.processServiceId, process.deploymentId);
                // console.log(template);
                this.templateInfo.dataOperate = template.dataOperate;
                this.templateInfo.nameGenerationMode = template.nameGenerationMode ? template.nameGenerationMode : '';
                this.templateInfo.serialNumberJson = template.serialNumberJson ? template.serialNumberJson : '';
                this.templateInfo.defaultFirstAssignee = template.defaultFirstAssignee;
                this.templateInfo.parentProcessInstanceMode = template.parentProcessInstanceMode;
                this.templateInfo.processTaskAssignerMode = template.processTaskAssignerMode;
                this.templateInfo.autoCompleteTask = template.autoCompleteTask;
                this.templateInfo.canViewAllFile = template.canViewAllFile;
                this.templateInfo.claimMode = template.claimMode;
                this.templateInfo.completeFirstTask = template.completeFirstTask;
                this.templateInfo.processViewPanes = template.processViewPanes;
                this.templateInfo.taskViewPanes = template.taskViewPanes;
                this.templateInfo.processExtJson = template.processExtJson;
                this.templateInfo.planTimeMode = template.planTimeMode;
                this.templateInfo.reports = template.reports;
                this.templateInfo.processServiceType = template.processServiceType;
                // console.log(this.templateInfo);
            },
            async handleEditTemplateInfo () {
                // console.log(this.templateInfo);
                if (this.saveMode === 1) {
                    await this.handlePublishProcess(this.templateInfo);// 发布
                } else {
                    await saveProcessTemplate(this.templateInfo); // 修改
                }
                // saveProcessInstanceTemplate 流程模板干预
                await this._initPage();
                this.isShowTemplateDesc = false;
            },
            handleTreeNode (data, node, tree) {
                this.templateInfo.processServiceType = data.id;
            },
            async changeExecuteType (executeType) {
                if (executeType === 1) {
                    let loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    let tasks = await getAllUserTask(null, this.processInstanceInfo.processServiceId, this.processInstanceInfo.id, this.processInstanceInfo.deploymentId);
                    this.taskList = tasks;
                    loading.close();
                }
            },
            handleChooseAssignee (row) {
                this.loadTimer = new Date().getTime();
                setTimeout(() => { // 初始化
                    this.$refs.userOrgPop._initPage();
                }, 0);
                this.isShowUserOrg = true;
                this.selectedTask = row;
                if (row.executor.hasOwnProperty('assigneeUsers')) {
                    this.selectedUser.selectedUserIds = row.executor.assigneeUsers;
                    this.selectedUser.selectedUserNames = row.executor.assigneeUsersName;
                } else {
                    this.selectedUser = {};
                }
                // console.log(this.selectedTask);
                // this.initSelectedUsers = [];
            },
            chooseProcessAssigneeUser () {
                this.loadTimer = new Date().getTime();
                setTimeout(() => { // 初始化
                    this.$refs.processUserOrgPop._initPage();
                }, 0);
                this.isShowProcessUserOrg = true;
            },
            processAssigneeSelectTrigger (selected) { // 流程负责人
                this.selectedProcessUser = selected;
                this.processInstanceInfo.assigneeUserId = selected.selectedUserIds;
                this.loadTimer = new Date().getTime();
            },
            handleClosePop () {
                this.isShowStartProcessDialog = false;
            },
            showList () {
                this.$emit('handleTemplateSwitch', false);
            },
            navToBusiniessProcessTab () {
                // console.log('processTempalte-navToBusiniessProcessTab');
                this.isShowStartProcessDialog = false;
                this.$emit('navToBusiniessProcessTab');
            },
            navToBusiniessTaskTab () {
                // console.log('processTempalte-navToBusiniessProcessTab');
                this.isShowStartProcessDialog = false;
                this.$emit('navToBusiniessTaskTab');
            }
        }
    };
</script>


<style lang="less">
  .process-Template-dialog {
        .el-dialog__body {
            margin-top: -3%;
            padding: 20px 50px 0px 20px;
			height: 100%;
        }
    }
    .process-template-list {
        width: 100%;
        margin-top: -25px;
        height: ~"calc(100% - 60px)";
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;

        .resetProcessInstance {
            padding: 7px 15px;
            vertical-align: middle;
            margin-left: 5px;
        }

        .process-item {
            height: 200px;
            width: 23%;
            // min-width: 15%;
            margin: 5px;
            border: 1px solid #e8edf1;

            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .el-card__body {
                flex: 1;
                display: flex;
                flex-direction: column;
            }
        }

        .process-item:hover {
            border: 1px solid #6db2bb;
        }

        .process-img {
            flex: 1;
            cursor: pointer;
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
        }

        .process-bottom {
            font-size: 12px;
            background-color: #e8edf1;
            padding: 5px;

            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
        .process-top {
            font-size: 12px;
            // background-color: #e8edf1;
            padding: 2px;

            // display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
    }
      .choosedProcessClass{
        background-color: #b5fb92;
      }
      .choosedClass:before {
        content: "*";
        color: #f56c6c;
        margin-right: 4px;
      }

  .template-list-pop {
        width: 100%;
        height:420px;
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;

        .process-item {
            height: 200px;
            width: 23%;
            // min-width: 15%;
            margin: 5px;
            border: 1px solid #e8edf1;

            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .el-card__body {
                flex: 1;
                display: flex;
                flex-direction: column;
            }
        }

        .process-item:hover {
            border: 1px solid #6db2bb;
        }

        .process-img {
            flex: 1;
            cursor: pointer;
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
        }

        .process-bottom {
            font-size: 12px;
            background-color: #e8edf1;
            padding: 5px;

            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
        .process-top {
            font-size: 12px;
            // background-color: #e8edf1;
            padding: 2px;

            // display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
    }

  .tools-bar-pop{
      margin-top: -20px;
      display: flex;
      -webkit-box-orient: horizontal;
      -webkit-box-direction: normal;
      -ms-flex-direction: row;
      flex-direction: row;
      -webkit-box-pack: justify;
      justify-content: space-between;
  }

  .processPopClass{
    .el-dialog__body {
        padding: 0px 0px;
        color: #606266;
        font-size: 14px;
        word-break: break-all;
      }
  }

</style>



// WEBPACK FOOTER //
// src/pages/process/ProcessTemplate/ProcessTemplate.vue